
interface ArticleProps {
  title: string;
  description: string;
  imageUrl: string;
  datePublished: string;
  dateModified?: string;
  author: {
    name: string;
    url?: string;
  };
  url: string;
  sections?: {
    title: string;
    content: string;
  }[];
  keywords?: string[];
  wordCount?: number;
}

/**
 * Generate enhanced Article schema with content sections
 */
export function generateEnhancedArticleSchema(article: ArticleProps) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.description,
    "image": article.imageUrl,
    "datePublished": article.datePublished,
    "dateModified": article.dateModified || article.datePublished,
    "author": {
      "@type": "Person",
      "name": article.author.name,
      ...(article.author.url && { "url": article.author.url })
    },
    "publisher": {
      "@type": "Organization",
      "name": "Grandpal",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.grandpal.ie/lovable-uploads/b67e8743-f24e-45cd-ba77-2a1ae609411c.png"
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://www.grandpal.ie${article.url}`
    },
    ...(article.sections && {
      "articleBody": article.sections.map(section => 
        `${section.title}\n\n${section.content}`
      ).join('\n\n')
    }),
    ...(article.keywords && { "keywords": article.keywords }),
    ...(article.wordCount && { "wordCount": article.wordCount })
  };
}
